export default function(num){
  if(!num || typeof num !== 'number') return num || '';
  return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}